import { jsx as a, jsxs as r } from "react/jsx-runtime";
import { Link as i } from "react-router-dom";
function c({ menus: t }) {
  return /* @__PURE__ */ a("aside", { className: "flex-shrink-0 md:w-64 ", children: /* @__PURE__ */ a("ul", { children: t.map((e) => /* @__PURE__ */ r("li", { className: "mt-8", children: [
    /* @__PURE__ */ a("h5", { className: "px-3 mb-3 text-sm font-semibold tracking-wide text-gray-900 uppercase dark:text-gray-200 lg:mb-3 lg:text-xs", children: e.label }),
    e.routes ? /* @__PURE__ */ a("ul", { children: e.routes.map((l) => /* @__PURE__ */ a("li", { children: /* @__PURE__ */ r(
      i,
      {
        className: "relative block px-3 py-2 text-gray-500 transition-colors duration-200 dark:text-gray-300 hover:underline hover:text-gray-900",
        to: l.path,
        children: [
          /* @__PURE__ */ a("span", { className: "absolute inset-0 rounded-md opacity-0 bg-cyan-50" }),
          /* @__PURE__ */ a("span", { className: "relative", children: l.label })
        ]
      }
    ) }, l.path)) }) : null
  ] }, e.path)) }) });
}
export {
  c as NavBar
};
